import {
  ContentImage,
  NewContentImage
} from '@/components/community/utils/types';

export const isNewContentImage = (
  image: ContentImage
): image is NewContentImage => typeof image !== 'string';
